import { render, staticRenderFns } from "./TruncateTextWithHover.vue?vue&type=template&id=a63c97be"
import script from "./TruncateTextWithHover.vue?vue&type=script&lang=js"
export * from "./TruncateTextWithHover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports